














import { computed, defineComponent, PropType, toRefs, watch } from '@nuxtjs/composition-api'

import useProxyValue from '@/composables/use-proxy-value'

export default defineComponent({
  props: {
    value: {
      type: Array as unknown as PropType<[number, number]>,
      default: () => [0, Infinity],
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 10000,
    },
  },
  setup (props, { emit }) {
    const { proxyValue } = useProxyValue(toRefs(props).value, emit)

    const start = computed(() => props.value?.[0])
    const end = computed(() =>
      (props.value?.[1] === Infinity)
        ? props.max
        : props.value?.[1]
    )

    // 將最大值和最小值歸位至整數
    const interval = 100
    const divisibleMin = computed(() => {
      const { min } = props
      if (min % interval === 0) return min
      const value = Math.ceil((min - interval) / interval) * interval
      return value >= 0 ? value : 0
    })
    const divisibleMax = computed(() => {
      const { max } = props
      if (max % interval === 0) return max
      return Math.floor((max + interval) / interval) * interval
    })

    watch(proxyValue, (value) => {
      emit('update', [Math.max(divisibleMin.value, value[0]), Math.min(divisibleMax.value, value[1])])
    }, { immediate: true })

    return {
      proxyValue,
      start,
      end,
      interval,
      divisibleMin,
      divisibleMax,
    }
  },
})
